import { Service, inject } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {GoogleService} from "./google-service";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {PartSerialInformation} from "../dialogs/parts-dialog/part-serial-information";
import {WarrantyClaim} from "../dialogs/parts-dialog/warranty-claim";
import {SewpWarranty} from "../dialogs/parts-dialog/sewp-warranty";
import {DecoderData} from "../model/decoder-data";
import {StdWarranty} from "../dialogs/parts-dialog/std-warranty";
import {ExtWarranty} from "../dialogs/parts-dialog/ext-warranty";
import {ProductInformation} from "../dialogs/parts-dialog/product-information";
import {DealerConsumerInformation} from "../dialogs/parts-dialog/dealer-consumer-information";
import {Part} from "../products/part";
import {DefectCode} from "../model/defect-code";
import {Competitor} from "../model/competitor";
import {SpecialQuoteRequest} from "../model/special-quote-request";
import {SpecialQuote} from "../model/special-quote";

@Service()
export class SerialNumberResearchService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'serialnumberresearch/';

  public getPartSerialInformation(serialNumber: string): Observable<PartSerialInformation> {
    let url = this.urlBase + 'partSerialInformation/' + serialNumber;
    return this.http.get<PartSerialInformation>(url, {headers: this.getRequestHeaders()});
  }

  public getDealerConsumerInformation(serialNumber: string): Observable<DealerConsumerInformation> {
    let url = this.urlBase + 'dealerconsumerinformation/' + serialNumber;
    return this.http.get<DealerConsumerInformation>(url, {headers: this.getRequestHeaders()});
  }

  public getProductInformation(partNumber: string): Observable<ProductInformation> {
    let url = this.urlBase + 'productInformation/' + partNumber;
    return this.http.get<ProductInformation>(url, {headers: this.getRequestHeaders()});
  }

  public getDecoderData(modelNumber: string): Observable<DecoderData> {
    let url = this.urlBase + 'decoderdata/' + modelNumber;
    return this.http.get<DecoderData>(url, {headers: this.getRequestHeaders()});
  }

  public getWarrantyClaims(serialNumber: string): Observable<WarrantyClaim[]> {
    let url = this.urlBase + 'warrantyclaims/' + serialNumber;
    return this.http.get<WarrantyClaim[]>(url, {headers: this.getRequestHeaders()});
  }

  public getSewpWarranties(serialNumber: string): Observable<SewpWarranty[]> {
    let url = this.urlBase + 'sewpwarranties/' + serialNumber;
    return this.http.get<SewpWarranty[]>(url, {headers: this.getRequestHeaders()});
  }

  public getReplacementParts(partNumber: string): Observable<Part[]> {
    let url = this.urlBase + 'replacementparts/' + partNumber;
    return this.http.get<Part[]>(url, {headers: this.getRequestHeaders()});
  }

  public getDefectCodesOrDefault(partNumber: string): Observable<DefectCode[]> {
    let url = this.urlBase + 'defectcodesordefault/' + partNumber;
    return this.http.get<DefectCode[]>(url, {headers: this.getRequestHeaders()});
  }

  public getStdWarranties(partSerialInformation: PartSerialInformation): Observable<StdWarranty[]> {
    let url = this.urlBase + 'stdwarranties';
    let body = JSON.stringify(partSerialInformation);
    return this.http.post<StdWarranty[]>(url, body, {headers: this.getPostHeaders()});
  }

  public getExtWarranties(partSerialInformation: PartSerialInformation): Observable<ExtWarranty[]> {
    let url = this.urlBase + 'extwarranties';
    let body = JSON.stringify(partSerialInformation);
    return this.http.post<ExtWarranty[]>(url, body, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }
}
